import { DEPLOYMENT_TIER } from '@/configuration/client';

const isProduction = (): boolean => DEPLOYMENT_TIER === 'production';

export default isProduction;
